export interface FeaturesEnabled {
    screenshotEnabled: boolean;
    appTrackingEnabled: boolean;
    urlTrackingEnabled: boolean;
    presenceTrackingEnabled: boolean;
    deviceTrackingEnabled: boolean;
    liveScreenEnabled: boolean;
}

export const getFeaturesEnabled = (): Partial<FeaturesEnabled> => {
    try {
        const data = localStorage.getItem("featuresEnabled");
        return data ? JSON.parse(data) : {};
    } catch (e) {
        return {};
    }
};

export const setFeaturesEnabled = (features: Partial<FeaturesEnabled>) => {
    localStorage.setItem("featuresEnabled", JSON.stringify(features));
    // Dispatch event so any listening component (like WorkSummary) re-renders instantly
    window.dispatchEvent(new Event("featuresEnabledChanged"));
};